import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonDelete } from "../../generic/common/ButtonDelete";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { ButtonSecondary } from "../../generic/common/ButtonSecondary";
import { IdIcon } from "../../generic/icon/IdIcon";
import { TextLoca } from "../../generic/text/TextLoca";
export var FoundEditBtns = React.memo(function (_a) {
    var coop = _a.coop, coopFoundCost = _a.coopFoundCost, onConfirmClick = _a.onConfirmClick, onUpdateCancel = _a.onUpdateCancel, onUpdateClick = _a.onUpdateClick;
    if (coop) {
        return (React.createElement("div", { className: "flex flex--spaced flex--around found-btn__container" },
            React.createElement(ButtonDelete, { onClick: onUpdateCancel },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cancel })),
            React.createElement(ButtonPrimary, { onClick: onUpdateClick },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.save }))));
    }
    else {
        return (React.createElement(ButtonDefault, { onClick: onConfirmClick, component: ButtonSecondary, amount: coopFoundCost, icon: IdIcon.GoldIcn }));
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/found-edit/FoundEditBtns.tsx
// module id = 2582
// module chunks = 3